module.exports = __webpack_public_path__ + "img/whatsapp.0df83794.png";